import type { IconProps } from "./icon-types";

/**
 * 원 안 정립 "i" — info/안내 상태 표시(dot 위 · stem 아래).
 * Toast info tone 등 status 표현에서 공용.
 */
export const InfoIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="8" cy="8" r="6" />
    <circle cx="8" cy="5.2" r="0.85" fill="currentColor" stroke="none" />
    <path d="M8 7.6v3.2" />
  </svg>
);
